import i18n from '@rover/utilities/translation';

const formatAddonLine = (addon, percent, price, priceFirstTemplate) => {
  return priceFirstTemplate
    ? `$${price} x 1 ${addon.name} (${percent}%)`
    : `${addon.name} (${percent}%) @ $${price}`;
};

const getAlternativeRateAddOnsSum = alternativeRateAddOns =>
  alternativeRateAddOns.reduce(
    (sum, addon) => sum + parseFloat(addon.price_per_unit_obj.amount),
    0
  );

export const getExtendedCareDescription = (
  alternativeRateAddOns,
  extendedCareAddon,
  priceFirstFormatting = false
) => {
  const altRateSum = getAlternativeRateAddOnsSum(alternativeRateAddOns);

  const extendedCareCoefficient =
    parseFloat(extendedCareAddon.price_per_unit_obj.amount) / altRateSum;
  const percent = (extendedCareCoefficient * 100).toFixed(0);

  return extendedCareAddon.price_per_unit_obj.amount === 0
    ? []
    : alternativeRateAddOns.map(addon =>
        formatAddonLine(
          addon,
          percent,
          parseFloat(addon.price_per_unit_obj.amount * extendedCareCoefficient).toFixed(2),
          priceFirstFormatting
        )
      );
};

export const getExtendedCareHours = (alternativeRateAddOns, extendedCareAddon) => {
  const altRateSum = getAlternativeRateAddOnsSum(alternativeRateAddOns);

  const extendedCareCoefficient =
    parseFloat(extendedCareAddon.price_per_unit_obj.amount) / altRateSum;

  if (extendedCareCoefficient === 1) {
    return i18n._('8+ hours');
  }
  if (extendedCareCoefficient === 0.5) {
    return i18n._('2-8 hours');
  }

  return '';
};



// WEBPACK FOOTER //
// ../utilities/addonDescription.js